export function ProfileUserEmpty({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="200"
        height="152"
        viewBox="0 0 200 152"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M57 108C65.8366 108 73 100.837 73 92C73 83.1634 65.8366 76 57 76C48.1634 76 41 83.1634 41 92C41 100.837 48.1634 108 57 108Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M39 131C39 126.226 40.8964 121.648 44.2721 118.272C47.6477 114.896 52.2261 113 57 113C61.7739 113 66.3523 114.896 69.7279 118.272C73.1036 121.648 75 126.226 75 131H39Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M143 108C151.837 108 159 100.837 159 92C159 83.1634 151.837 76 143 76C134.163 76 127 83.1634 127 92C127 100.837 134.163 108 143 108Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M125 131C125 126.226 126.896 121.648 130.272 118.272C133.648 114.896 138.226 113 143 113C147.774 113 152.352 114.896 155.728 118.272C159.104 121.648 161 126.226 161 131H125Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M64 146C64 136.983 67.7928 128.335 74.5442 121.958C81.2955 115.582 90.4522 112 100 112C109.548 112 118.705 115.582 125.456 121.958C132.207 128.335 136 136.983 136 146H64Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M100 108C117.121 108 131 94.1208 131 77C131 59.8792 117.121 46 100 46C82.8792 46 69 59.8792 69 77C69 94.1208 82.8792 108 100 108Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M85 70C89 74.6667 93 74.6667 97 70"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M105 70C109 74.6667 113 74.6667 117 70"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M93 84C98.3333 88 103.667 88 109 84"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          opacity="0.18"
          d="M79.5 82.5C81.1569 82.5 82.5 81.1569 82.5 79.5C82.5 77.8431 81.1569 76.5 79.5 76.5C77.8431 76.5 76.5 77.8431 76.5 79.5C76.5 81.1569 77.8431 82.5 79.5 82.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.18"
          d="M119.5 82.5C121.157 82.5 122.5 81.1569 122.5 79.5C122.5 77.8431 121.157 76.5 119.5 76.5C117.843 76.5 116.5 77.8431 116.5 79.5C116.5 81.1569 117.843 82.5 119.5 82.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M74 24C73.3333 32.6667 76 40 82 46"
          stroke="var(--clr-title)"
          strokeOpacity="0.2"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeDasharray="1 7"
        />
        <path
          opacity="0.9"
          d="M72 18.0002C71.0351 10.8539 75.4629 6.33789 81.294 8.06932C80.4614 14.3388 76.4719 17.9561 72 18.0002Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.65"
          d="M72 18C65.7305 17.1673 62.99 11.3803 65.6202 5.98755C71.013 8.61778 73.2931 13.0676 72 18Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.45"
          d="M159 51L161 56L166 58L161 60L159 65L157 60L152 58L157 56L159 51Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M29.6 67.2C31.0359 67.2 32.2 66.0359 32.2 64.6C32.2 63.1641 31.0359 62 29.6 62C28.1641 62 27 63.1641 27 64.6C27 66.0359 28.1641 67.2 29.6 67.2Z"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
